import React from 'react';
import { Button, ButtonGroup, Card, CssBaseline, Grid, Typography, withStyles } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import { IoSubwayOutline, IoBusOutline } from 'react-icons/io5';
import { AiOutlineCar } from 'react-icons/ai';
import { FaArrowAltCircleRight } from 'react-icons/fa';

import Stack from '@mui/material/Stack';
import SubTitle from '../components/Text/SubTitle';

const styles = (theme) => ({
  btn: {
    cursor: 'pointer',
    textTransform: 'none',
    height: 50,
    backgroundColor: '#376092',
    color: '#fff',
  },
  card: {
    width: '240px',
    height: '240px',
  },
});

const CustomTypography = withStyles((theme) => ({
  root: {
    // fontWeight: 'bold',
    fontSize: '1.4em',
    color: '#237a9d',
    textAlign: 'center',
  },
}))(Typography);

class GettingVenue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
      tabValue: 0,
    };
  }

  componentDidMount() {}
  handleState(key, value) {
    this.setState({ [key]: value });
  }

  render() {
    const { tabValue } = this.state;
    const { classes } = this.props;

    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={7} SIdx={3} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Getting to the Venue</MainTitle>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <ButtonGroup color="primary" fullWidth disableElevation style={{ width: '100%' }}>
                  <Button
                    variant={tabValue === 0 ? 'contained' : 'outlined'}
                    onClick={() => this.handleState('tabValue', 0)}
                    style={{ fontSize: 'large' }}
                  >
                    KOREAN
                  </Button>
                  <Button
                    variant={tabValue === 1 ? 'contained' : 'outlined'}
                    onClick={() => this.handleState('tabValue', 1)}
                    style={{ fontSize: 'large' }}
                  >
                    ENGLISH
                  </Button>
                </ButtonGroup>
              </div>

              {tabValue === 0 && (
                <Grid container style={{ paddingTop: 48 }}>
                  <SubTitle>오시는 길</SubTitle>
                  <Grid container justifyContent="center" style={{ paddingTop: 32 }}>
                    <Grid item xs={4} container justifyContent="center">
                      <Card style={{ width: '100%', height: '100%' }}>
                        <Grid container justifyContent="center" alignItems="center">
                          <Grid container justifyContent="center" alignItems="center" className={classes.card}>
                            <Stack spacing={2} style={{ width: '100%', height: '100%' }}>
                              <Grid container justifyContent="center">
                                <IoSubwayOutline size={80} style={{ color: '#237a9d', marginTop: 16 }} />
                              </Grid>
                              <CustomTypography>대중교통</CustomTypography>
                              <Button
                                fullWidth
                                variant="contained"
                                style={{ textTransform: 'none', height: 50, backgroundColor: '#376092', color: '#fff' }}
                                endIcon={<FaArrowAltCircleRight />}
                                onClick={() => {
                                  window.open('https://seoul.intercontinental.com/welcome/MapPublic', '_blank');
                                }}
                              >
                                상세보기
                              </Button>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item xs={4} container justifyContent="center">
                      <Card style={{ width: '100%', height: '100%' }}>
                        <Grid container justifyContent="center" alignItems="center">
                          <Grid container justifyContent="center" alignItems="center" className={classes.card}>
                            <Stack spacing={2} style={{ width: '100%', height: '100%' }}>
                              <Grid container justifyContent="center">
                                <AiOutlineCar size={80} style={{ color: '#237a9d', marginTop: 16 }} />
                              </Grid>
                              <CustomTypography>자가용</CustomTypography>
                              <Button
                                fullWidth
                                variant="contained"
                                style={{ textTransform: 'none', height: 50, backgroundColor: '#376092', color: '#fff' }}
                                endIcon={<FaArrowAltCircleRight />}
                                onClick={() => {
                                  window.open('https://seoul.intercontinental.com/welcome/MapCar', '_blank');
                                }}
                              >
                                상세보기
                              </Button>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item xs={4} container justifyContent="center">
                      <Card style={{ width: '100%', height: '100%' }}>
                        <Grid container justifyContent="center" alignItems="center">
                          <Grid container justifyContent="center" alignItems="center" className={classes.card}>
                            <Stack spacing={2} style={{ width: '100%', height: '100%' }}>
                              <Grid container justifyContent="center">
                                <IoBusOutline size={80} style={{ color: '#237a9d', marginTop: 16 }} />
                              </Grid>
                              <CustomTypography>공항버스</CustomTypography>
                              <Button
                                fullWidth
                                variant="contained"
                                style={{ textTransform: 'none', height: 50, backgroundColor: '#376092', color: '#fff' }}
                                endIcon={<FaArrowAltCircleRight />}
                                onClick={() => {
                                  window.open('https://seoul.intercontinental.com/welcome/MapBus', '_blank');
                                }}
                              >
                                상세보기
                              </Button>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {tabValue === 1 && (
                <Grid container style={{ paddingTop: 48 }}>
                  <SubTitle>LOCATION</SubTitle>
                  <Grid container justifyContent="center" style={{ paddingTop: 32 }}>
                    <Grid item xs={4} container justifyContent="center">
                      <Card style={{ width: '100%', height: '100%' }}>
                        <Grid container justifyContent="center" alignItems="center">
                          <Grid container justifyContent="center" alignItems="center" className={classes.card}>
                            <Stack spacing={2} style={{ width: '100%', height: '100%' }}>
                              <Grid container justifyContent="center">
                                <IoSubwayOutline size={80} style={{ color: '#237a9d', marginTop: 16 }} />
                              </Grid>
                              <CustomTypography>Public Transportation</CustomTypography>
                              <Button
                                fullWidth
                                variant="contained"
                                style={{ textTransform: 'none', height: 50, backgroundColor: '#376092', color: '#fff' }}
                                endIcon={<FaArrowAltCircleRight />}
                                onClick={() => {
                                  window.open('https://seoul.intercontinental.com/eng/welcome/MapPublic ', '_blank');
                                }}
                              >
                                View Details
                              </Button>
                            </Stack>
                          </Grid>{' '}
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item xs={4} container justifyContent="center">
                      <Card style={{ width: '100%', height: '100%' }}>
                        <Grid container justifyContent="center" alignItems="center">
                          <Grid container justifyContent="center" alignItems="center" className={classes.card}>
                            <Stack spacing={2} style={{ width: '100%', height: '100%' }}>
                              <Grid container justifyContent="center">
                                <AiOutlineCar size={80} style={{ color: '#237a9d', marginTop: 16 }} />
                              </Grid>
                              <CustomTypography>Car</CustomTypography>
                              <Button
                                fullWidth
                                variant="contained"
                                style={{ textTransform: 'none', height: 50, backgroundColor: '#376092', color: '#fff' }}
                                endIcon={<FaArrowAltCircleRight />}
                                onClick={() => {
                                  window.open('https://seoul.intercontinental.com/eng/welcome/MapCar ', '_blank');
                                }}
                              >
                                View Details
                              </Button>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item xs={4} container justifyContent="center">
                      <Card style={{ width: '100%', height: '100%' }}>
                        <Grid container justifyContent="center" alignItems="center">
                          <Grid container justifyContent="center" alignItems="center" className={classes.card}>
                            <Stack spacing={2} style={{ width: '100%', height: '100%' }}>
                              <Grid container justifyContent="center">
                                <IoBusOutline size={80} style={{ color: '#237a9d', marginTop: 16 }} />
                              </Grid>
                              <CustomTypography>Airport Limousine Bus</CustomTypography>
                              <Button
                                fullWidth
                                variant="contained"
                                style={{ textTransform: 'none', height: 50, backgroundColor: '#376092', color: '#fff' }}
                                endIcon={<FaArrowAltCircleRight />}
                                onClick={() => {
                                  window.open('https://seoul.intercontinental.com/eng/welcome/MapBus ', '_blank');
                                }}
                              >
                                View Details
                              </Button>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(GettingVenue);
